const SvgClose = props => (
  <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
    <path d='M19.682 18.145a1.086 1.086 0 01-1.537 1.537L12 13.536l-6.145 6.146a1.086 1.086 0 01-1.537-1.537L10.464 12 4.318 5.855a1.086 1.086 0 111.537-1.537L12 10.464l6.145-6.146a1.086 1.086 0 011.537 1.537L13.536 12l6.146 6.145z' />
  </svg>
);

export default SvgClose;
